import React from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';

const WelcomeTourAlert = ({ open, onOpenShortcuts, onDismiss }) => {
  if (!open) return null;

  return (
    <Alert
      severity="info"
      variant="outlined"
      sx={{ mb: 2, alignItems: 'flex-start' }}
      action={
        <Stack direction="row" spacing={1}>
          <Button size="small" onClick={onOpenShortcuts}>
            Shortcuts
          </Button>
          <Button size="small" variant="contained" onClick={onDismiss}>
            Got it
          </Button>
        </Stack>
      }
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
        First time here?
      </Typography>
      <Typography variant="body2">
        1. Create a root node or load a demo.
        <br />
        2. Use node actions to add, edit, insert, and execute.
        <br />
        3. Use Ctrl/Cmd+S to save draft and Ctrl/Cmd+Shift+K to view shortcuts.
      </Typography>
    </Alert>
  );
};

export default WelcomeTourAlert;
